var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled from 'styled-components';
import { GRID_UNIT } from '../../utilities/grid';
var DEFAULT_BOX_PADDING = 2 * GRID_UNIT;
export var Box = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  padding: ", ";\n"], ["\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  padding: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.interface.neutral.light;
}, GRID_UNIT / 2, function (_a) {
  var _b = _a.padding,
    padding = _b === void 0 ? DEFAULT_BOX_PADDING : _b;
  return "".concat(padding, "px");
});
var templateObject_1;